import React from "react";

import { StyledLayout } from "./styles";

const Layout = ({ children, ...others }) => {
    return <StyledLayout {...others}>{children}</StyledLayout>;
};
Layout.defaultProps = {
    justify: "flex-start",
    align: "stretch",
};

export default Layout;
